module.exports = __webpack_public_path__ + "static/img/son13_active.9362c15e.png";